import { combineSlices, configureStore } from "@reduxjs/toolkit";

import { SetupObjectPrototypeMethods } from "lib/mods";
import { BusinessObjectsSlice, ContainmentsSlice, TokenSlice, UserSearchSlice, UserSlice } from "./slices";
import { ApiSlice } from "./slices/apiSlice";
import { DownloadDisabledTimersSlice } from "./slices/downloadDisabledTimersSlice";

const rootReducer = combineSlices(
	BusinessObjectsSlice,
	ContainmentsSlice,
	UserSlice,
	UserSearchSlice,
	TokenSlice,
	ApiSlice,
	DownloadDisabledTimersSlice
);

const ignoreIterActionsMiddleware = () => (next: any) => (action: any) => {
	// Ignore any actions that come from iterator operations
	if (
		action.type === "Symbol(Symbol.iterator)" ||
		action.type?.toString().Contains("iterator") ||
		action.type === "@@iter" ||
		action.type?.Contains("iter")
	) {
		return action.payload
	}
	return next(action)
}


export const Store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => {
		return getDefaultMiddleware({
			serializableCheck: false,
			immutableStateInvariant: false,
		}).prepend(ignoreIterActionsMiddleware);
	},
});

export type Store = typeof Store;

SetupObjectPrototypeMethods();
